"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationConfigComponent = exports.ResponseUploadComponent = exports.RMUploadComponent = exports.StudentUploadComponent = exports.EngOperationsComponent = exports.MathOperationsComponent = exports.RMReportComponent = exports.RMRatingComponent = exports.RMAttendanceComponent = exports.RMAuditComponent = exports.RMAllComponent = exports.ParentNewComponent = exports.ParentAllComponent = exports.HomeComponent = exports.CL = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _App = require("./App");

var serviceWorker = _interopRequireWildcard(require("./serviceWorker"));

require("./index.css");

var _home = _interopRequireDefault(require("./views/app-views/home"));

var _All = _interopRequireDefault(require("./views/app-views/parent/All"));

var _New = _interopRequireDefault(require("./views/app-views/parent/New"));

var _allRM = _interopRequireDefault(require("./views/app-views/rm/allRM"));

var _Audit = _interopRequireDefault(require("./views/app-views/rm/Audit"));

var _Rating = _interopRequireDefault(require("./views/app-views/rm/Rating"));

var _Reports = _interopRequireDefault(require("./views/app-views/rm/Reports"));

var _RMAttendance = _interopRequireDefault(require("./views/app-views/rm/RM attendance"));

var _MathResponse = _interopRequireDefault(require("./views/app-views/operations/MathResponse"));

var _EnglishResponse = _interopRequireDefault(require("./views/app-views/operations/EnglishResponse"));

var _Student = _interopRequireDefault(require("./views/app-views/uploadFile/Student"));

var _RM = _interopRequireDefault(require("./views/app-views/uploadFile/RM"));

var _MorningResp = _interopRequireDefault(require("./views/app-views/uploadFile/MorningResp"));

var _NavigationConfig = _interopRequireDefault(require("./configs/NavigationConfig"));

var _reactRouterDom = require("react-router-dom");

_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_App.App, null)), document.getElementById('root')); // If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA


serviceWorker.unregister();
var CL = _App.App;
exports.CL = CL;
var HomeComponent = _home.default;
exports.HomeComponent = HomeComponent;
var ParentAllComponent = _All.default;
exports.ParentAllComponent = ParentAllComponent;
var ParentNewComponent = _New.default;
exports.ParentNewComponent = ParentNewComponent;
var RMAllComponent = _allRM.default;
exports.RMAllComponent = RMAllComponent;
var RMAuditComponent = _Audit.default;
exports.RMAuditComponent = RMAuditComponent;
var RMAttendanceComponent = _RMAttendance.default;
exports.RMAttendanceComponent = RMAttendanceComponent;
var RMRatingComponent = _Rating.default;
exports.RMRatingComponent = RMRatingComponent;
var RMReportComponent = _Reports.default;
exports.RMReportComponent = RMReportComponent;
var MathOperationsComponent = _MathResponse.default;
exports.MathOperationsComponent = MathOperationsComponent;
var EngOperationsComponent = _EnglishResponse.default;
exports.EngOperationsComponent = EngOperationsComponent;
var StudentUploadComponent = _Student.default;
exports.StudentUploadComponent = StudentUploadComponent;
var RMUploadComponent = _RM.default;
exports.RMUploadComponent = RMUploadComponent;
var ResponseUploadComponent = _MorningResp.default;
exports.ResponseUploadComponent = ResponseUploadComponent;
var NavigationConfigComponent = _NavigationConfig.default;
exports.NavigationConfigComponent = NavigationConfigComponent;